import { hasEpisodeLayout } from '../../contexts/AudioPlayerContext';
import EpisodeDocument, { EpisodeDocumentProps } from './EpisodeDocument';
import VideoDocument, { VideoDocumentProps } from './VideoDocument';

// An episode of a podcast, audio or video, shows the playlist of its season; other videos keep
// the full video page
function EpisodeOrVideoDocument(props: EpisodeDocumentProps & VideoDocumentProps) {
    if (hasEpisodeLayout(props as Partial<PodcastDocument>)) {
        return <EpisodeDocument {...props} />;
    }
    return <VideoDocument {...props} />;
}

export default EpisodeOrVideoDocument;
